<template>
    <div class="page-recharge">
        <p class="channel-list-title">{{ $t('selectChannel') }}</p>
        <div class="channel-list">
            <div v-for="(channel, channelIndex) in channels"
                 class="channel-item" :class="channel.key" @click="openContent(channelIndex)">
                <img :src="'../../static/img/recharge/channels/' + channel.key + '.png'" class="channel-logo">
            </div>
        </div>

        <recharge-popup :channelInfo="channelInfo" :showRecharge="showRecharge" :channelId="channelId"
                        @closePopup="showRecharge = false"></recharge-popup>

    </div>
</template>

<script>
    import {channelDetail as allChannels} from '../../config/channels'
    import {channelDetailNew as allChannelsNew} from '../../config/channelsNew'
    import RechargePopup from '../recharge/RechargePopup.vue'

    export default {
        data() {
            return {
                channels: allChannels,
                channelsNew: allChannelsNew,
                loading: false,
                selectedChannelIndex: -1,
                selectedChannelIndexNew: -1,
                showRecharge: false,
                showRechargeNew: false,
                channelId: 0,
            };
        },
        computed: {
            user() {
                return this.$store.state.user;
            },
            channelInfo() {
                if(this.showRechargeNew === false){
                    return this.channels[this.selectedChannelIndex];
                } else {
                    return this.channelsNew[this.selectedChannelIndex];
                }
            },
        },
        components: {
            RechargePopup
        },
        methods: {
            openContent(channelIndex) {
                const isLogin = Boolean(this.$store.state.user.accessToken);
                if (!isLogin) {
                    this.$store.commit('controlLoginPopup', true);
                    return;
                }
                this.selectedChannelIndex = channelIndex;
                this.showRecharge = true;
                this.showRechargeNew = false;
                if(channelIndex == 6 || channelIndex == 3){
                    this.channelId = this.$t('selectChannel');
                }else{
                    this.channelId = this.$t('selectCurrency');
                }
            },
            openContentNew(channelIndex) {
                const isLogin = Boolean(this.$store.state.user.accessToken);
                if (!isLogin) {
                    this.$store.commit('controlLoginPopup', true);
                    return;
                }
                this.selectedChannelIndex = channelIndex;
                this.showRecharge = true;
                this.showRechargeNew = true;
                this.channelId = this.$t('selectChannel');
            }
        },
        created() {
            let status = this.$route.query.status;
            const that = this;

            if (status == 'finish') {
                this.$alert(this.$t('rechargeFinishCheckLater'), this.$t('rechargeFinish'), {
                    confirmButtonText: this.$t('confirm'),
                    callback: () => {
                        that.$router.push('recharge');
                    }
                });
            }
            if (status == 'cancel') {
                this.$alert(this.$t('rechargeCancelQuestAgain'), this.$t('rechargeCancel'), {
                    confirmButtonText: this.$t('confirm'),
                    callback: () => {
                        that.$router.push('recharge');
                    }
                });
            }

        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../../assets/scss/lib";

    .channel-list-title {
        font-size: 20px;
        margin: 20px 0;
        height: 30px;
        line-height: 30px;
        text-align: center;
    }

    .channel-list {
      $list-width: 750px;
      $margin: 30px;
      $count-row: 3;
      $item-width: ($list-width - ($count-row - 1) * $margin) / $count-row;
      $item-height: 80px;
      justify-content: normal;
      width: $list-width;
      margin: 50px auto 0;
      @include flex;
      @include flex-wrap;
      .channel-item {
        width: $item-width;
        height: $item-height;
        overflow: hidden;
        margin-bottom: $margin;
        margin-left: 10px;
        margin-right: 10px;
        border: 1px solid $blue-color;
        border-radius: 5px;
        cursor: pointer;
        @include flex-column-center;
        &:hover {
          border: 4px solid $blue-color;
        }
        .channel-logo {
          height: 40px;
        }
        .channel-name {
          margin-top: 12px;
          font-size: 14px;
        }
      }
      .channel-item.lunamycard{
        .channel-logo {
          height: 65px;
        }
      }
    }

</style>



// WEBPACK FOOTER //
// Recharge.vue?7dff0e10